import React, { useState, useRef, useEffect, FC, Dispatch, SetStateAction } from "react";
import { GoChevronDown } from "react-icons/go";
import { setCookie } from "../../lib/utils/cookies";


const defaultOptions = ["91", "964", "974", "971"];

interface PhoneNumberSelectProps {
  value: string;
  setValue: Dispatch<SetStateAction<string>>;
}

const PhoneNumberSelect: FC<PhoneNumberSelectProps> = ({ value, setValue }) => {
  const [open, setOpen] = useState<boolean>(false);
  const containerRef = useRef<HTMLDivElement>(null);

  // Close dropdown when clicking outside
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        containerRef.current &&
        !containerRef.current.contains(event.target as Node)
      ) {
        setOpen(false);
      }
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () =>
      document.removeEventListener("mousedown", handleClickOutside);
  }, []);

  const handleChange = (selectedValue: string) => {
    setCookie("countryCode",selectedValue,30);
    setValue(selectedValue);
    setOpen(false);
  };

  return (
    <div ref={containerRef} className="relative inline-block w-[20%]">
      <button
        onClick={() => setOpen(!open)}
        className=" px-4 py-2  bg-transparent text-left flex items-center justify-between w-full"
      >
        +{value || "Select country code"}
        <GoChevronDown/>
      </button>
      {open && (
        <ul className="absolute z-10 w-[100px] top-12 border border-sbBorder rounded-[5px] bg-white max-h-[150px] overflow-y-auto side_bar">
          {defaultOptions.map((option) => (
            <li
              key={option}
              onClick={() => handleChange(option)}
              className="px-4 py-2 hover:bg-gray-200 cursor-pointer"
            >
              +{option}
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default PhoneNumberSelect;
